import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import "../../css/header.scss";

const Header = ({ onMenuToggle, isSidebarCollapsed }) => {
  const [showMessagePopup, setShowMessagePopup] = useState(false);
  const [showUserDropdown, setShowUserDropdown] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const navigate = useNavigate();
  const messagePopupRef = useRef(null);
  const userDropdownRef = useRef(null);

  // 获取当前用户信息
  useEffect(() => {
    const userCookie = Cookies.get("user");
    if (userCookie) {
      try {
        const user = JSON.parse(userCookie);
        setCurrentUser(user);
      } catch (error) {
        console.error("解析用户信息失败:", error);
      }
    }
  }, []);

  // 显示/隐藏用户下拉菜单
  const toggleUserDropdown = () => {
    setShowUserDropdown(!showUserDropdown);
  };

  // 退出登录
  const handleLogout = () => {
    setShowUserDropdown(false);
    // 清除登录状态
    Cookies.remove("token");
    Cookies.remove("user");
    navigate("/");
  };

  // 点击外部关闭消息弹出框和用户下拉菜单
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        messagePopupRef.current &&
        !messagePopupRef.current.contains(event.target)
      ) {
        setShowMessagePopup(false);
      }
      if (
        userDropdownRef.current &&
        !userDropdownRef.current.contains(event.target)
      ) {
        setShowUserDropdown(false);
      }
    };

    if (showMessagePopup || showUserDropdown) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showMessagePopup, showUserDropdown]);

  return (
    <>
      <header className="header-container">
        <div className={`header-left ${isSidebarCollapsed ? "collapsed" : ""}`}>
          <div className="logo-section">
            <div className="logo-icon">
              <img alt="" src="/head/header1.svg" />
            </div>
            <span className={`logo-text ${isSidebarCollapsed ? "hidden" : ""}`}>
              Global E-Payment
            </span>
          </div>
          <button className="menu-btn" onClick={onMenuToggle}>
            <img alt="" src="/head/header2.png" />
          </button>
        </div>

        <div className="header-main">
          <div className="header-right">
            <div
              className="user-section"
              onClick={toggleUserDropdown}
              ref={userDropdownRef}
            >
              <div className="user-avatar">
                <img alt="" src="/head/header4-4.png" />
              </div>
              <span className="user-name">
                {currentUser?.username || currentUser?.email || "用户"}
              </span>
              {showUserDropdown && (
                <div className="user-dropdown-menu">
                  <div className="dropdown-item" onClick={handleLogout}>
                    <span>退出登录</span>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
